module.exports = __webpack_public_path__ + "static/media/yCRV-logo.aab3d701.png";